export default "__VITE_ASSET____9UdeW1__"